import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./sidebar.scss";
import Account from "../../assets/sidebar/account";
import FmiCases from "../../assets/sidebar/fmiCases";
import Orders from "../../assets/sidebar/orders";
import Product from "../../assets/sidebar/product";
import Dashboard from "../../assets/sidebar/dashboard";
import More from "../../assets/sidebar/more";
import FMILeads from "../../assets/sidebar/dealerPortal/FMILeads";
import Offer from "../../assets/sidebar/dealerPortal/Offer";
import Contact from "../../assets/sidebar/dealerPortal/Contact";
import Invoices from "../../assets/sidebar/dealerPortal/Invoices";

const dataResponsive = [
  {
    type: "item",
    icon: (color) => <Dashboard color={color} />,
    title: "Dashboard",
    link: "/home",
  },
  {
    type: "item",
    icon: (color) => <Account color={color} />,
    title: "Account",
    link: "/account",
  },
  {
    type: "item",
    icon: (color) => <Orders color={color} />,
    title: "Orders",
    link: "/orders",
  },
  {
    type: "item",
    icon: (color) => <Product color={color} />,
    title: "Products",
    link: "/products",
  },
  {
    type: "list",
    icon: (color) => <More color={color} />,
    title: "More",
    link: "/more",
    list: [
      {
        type: "item",
        icon: (color) => <FmiCases color={color} />,
        title: "FMI Cases",
        link: "/fmi-cases",
      },
      {
        type: "item",
        icon: (color) => <Contact color={color} />,
        title: "Contacts",
        link: "/contacts",
      },
      {
        type: "item",
        icon: (color) => <FMILeads color={color} />,
        title: "FMI Leads",
        link: "/fmi-leads",
      },
      {
        type: "item",
        icon: (color) => <Invoices color={color} />,
        title: "Invoices",
        link: "/invoices",
      },
      {
        type: "item",
        icon: (color) => <Offer color={color} />,
        title: "Schemes / Orders",
        link: "/schemes-orders",
      },
    ],
  },
];

const Sidebar = ({ pathname, isMatchedPath }) => {
  const [openMenu, setMenu] = useState("");
  const [openModalDialog, setopenModalDialog] = useState(false);

  useEffect(() => {
    if (!openModalDialog) {
      const pathArr = pathname.split("/");
      setMenu(`/${pathArr[1].replace(/\s+/g, "-").toLowerCase()}`);
    }
  }, [pathname, openModalDialog]);

  return (
    <div
      id="sidebar"
      className={`flex md:items-start items-center md:overflow-y-auto  md:py-4 pt-0 md:px-2 md:mt-[70px] ${
        isMatchedPath ? "md:flex hidden" : ""
      }`}
    >
      <ul className="flex w-full flex-col md:block hidden items-center">
        {dataResponsive.map((sideItem, i) =>
          sideItem?.type === "item" ? (
            <Link to={sideItem.link} className="w-full" key={i}>
              <li
                className={`${
                  openMenu && openMenu === sideItem.link ? "active" : ""
                } menuItem`}
                onClick={() => setMenu(sideItem.link)}
              >
                {sideItem.icon(
                  openMenu && openMenu === sideItem.link ? "#FFFFFF" : "#000000"
                )}
                {sideItem.title}
              </li>
            </Link>
          ) : sideItem?.type === "list" ? (
            sideItem?.list.map((sideSubItem, i2) =>
              sideSubItem.type === "item" ? (
                <Link to={sideSubItem.link} className="w-full" key={i2}>
                  <li
                    className={`${
                      openMenu && openMenu === sideSubItem.link ? "active" : ""
                    } menuItem`}
                    onClick={() => setMenu(sideSubItem.link)}
                  >
                    {sideSubItem.icon(
                      openMenu && openMenu === sideSubItem.link
                        ? "#FFFFFF"
                        : "#000000"
                    )}
                    {sideSubItem.title}
                  </li>
                </Link>
              ) : null
            )
          ) : null
        )}
      </ul>
      <ul className="flex w-full md:hidden block md:flex-col items-center m-0 ">
        {dataResponsive.map((sideItem, i) => {
          let moreTabActive = false;
          if (sideItem.type === "list") {
            let linksMore = sideItem?.list.map((item) => item?.link);
            let indexActiveMenu = linksMore.indexOf(openMenu);
            if (indexActiveMenu !== -1) {
              moreTabActive = true;
            }
          }

          return sideItem.type !== "list" ? (
            <Link to={sideItem.link} className="w-full" key={i}>
              <li
                className={`${
                  openMenu && openMenu === sideItem.link ? "active" : ""
                } menuItem`}
                onClick={() => {
                  setMenu(sideItem.link);
                  setopenModalDialog(false);
                }}
              >
                {sideItem.icon(
                  openMenu && openMenu === sideItem.link ? "#FFFFFF" : "#000000"
                )}
                {sideItem.title}
              </li>
            </Link>
          ) : (
            <React.Fragment key={i}>
              <Link
                className="w-full"
                onClick={() => {
                  setopenModalDialog(true);
                  setMenu("");
                }}
              >
                <li className={`${moreTabActive ? "active" : ""} menuItem`}>
                  {sideItem.icon(moreTabActive ? "#FFFFFF" : "#000000")}
                  {sideItem.title}
                </li>
              </Link>
              <div
                className={`relative z-2 ${
                  openModalDialog ? "h-fit block" : "h-0 hidden"
                } transition-all`}
                aria-labelledby="modal-title"
                role="dialog"
                aria-modal="true"
              >
                <div
                  onClick={() => setopenModalDialog(false)}
                  className="fixed inset-0 z-22 mb-[80px] backdrop-opacity-10 backdrop-invert bg-[#00000054] w-screen overflow-y-auto"
                >
                  <div
                    className={`flex ${
                      openModalDialog ? "min-h-full " : "h-0"
                    } items-end justify-center p-0 text-center sm:items-center sm:p-0 transition-all`}
                  >
                    <div className="w-full relative transform border-b-2 rounded-t-lg border-white-200 overflow-hidden rounded-0 bg-gray-50 text-left shadow-0 transition-all sm:my-8 sm:w-full sm:max-w-lg">
                      <div className="w-full px-4 py-4 sm:p-3">
                        <div className="w-full flex items-end pb-8 pt-4">
                          <div
                            onClick={() => setopenModalDialog(false)}
                            className="ml-auto cursor-pointer flex flex-shrink-0 items-center justify-center rounded-full sm:mx-0 sm:h-10 sm:w-10"
                          >
                            <svg
                              width="14"
                              height="14"
                              viewBox="0 0 16 16"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M10.64 8.0005L15.5898 3.05069C16.1367 2.50379 16.1367 1.61712 15.5898 1.07107L14.9299 0.411202C14.3828 -0.135871 13.4962 -0.135871 12.9501 0.411202L8.0005 5.36084L3.05069 0.410177C2.50379 -0.136726 1.61712 -0.136726 1.07107 0.410177L0.410177 1.07005C-0.136726 1.61712 -0.136726 2.50379 0.410177 3.04983L5.36084 8.0005L0.411202 12.9501C-0.135871 13.4972 -0.135871 14.3839 0.411202 14.9299L1.07107 15.5898C1.61798 16.1367 2.50464 16.1367 3.05069 15.5898L8.0005 10.64L12.9501 15.5898C13.4972 16.1367 14.3839 16.1367 14.9299 15.5898L15.5898 14.9299C16.1367 14.3828 16.1367 13.4962 15.5898 12.9501L10.64 8.0005Z"
                                fill="black"
                              />
                            </svg>
                          </div>
                        </div>
                        <ul className="flex flex-col w-full m-0 ">
                          {sideItem?.list.map((item, i) => (
                            <Link to={item.link} className="w-full" key={i}>
                              <li
                                className={`submenuItem  ${
                                  openMenu && openMenu === item?.link
                                    ? "active"
                                    : ""
                                }`}
                                onClick={() => {
                                  setMenu(item.link);
                                  setopenModalDialog(false);
                                }}
                              >
                                {item.icon(
                                  openMenu && openMenu === item.link
                                    ? "#FFFFFF"
                                    : "#000000"
                                )}
                                <p
                                  className={`ps-3 m-0 ${
                                    openMenu && openMenu === item?.link
                                      ? "text-black-100"
                                      : ""
                                  }`}
                                >
                                  {item.title}
                                </p>
                              </li>
                            </Link>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </React.Fragment>
          );
        })}
        {/* {dataResponsive.map((sideItem, i) => (
          <Link to={sideItem.link} className="w-full" key={i}>
            <li
              className={`${
                openMenu && openMenu === sideItem.link ? "active" : ""
              } rounded-lg w-full menuItem font-medium text-sm md:py-3	 flex flex-col items-center justify-center text-center`}
              onClick={() => setMenu(sideItem.link)}
            >
              {sideItem.icon(
                openMenu && openMenu === sideItem.link ? "#FFFFFF" : "#000000"
              )}
              {sideItem.title}
            </li>
          </Link>
        ))} */}
      </ul>
    </div>
  );
};

export default Sidebar;
